var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 260,
    viewBox: "0 0 288 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 288,
    height: 260
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.5 0.5H0.5V259.5H287.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.8 45.1C93.3998 48 77.5998 48.5 62.1998 51.2C41.2998 54.9 21.2998 61.1 10.0998 80.5C-0.900187 99.4 -2.90019 124.5 6.89981 144.3C13.9998 158.7 25.0998 172.3 38.6998 180.9C55.9998 191.8 75.0998 200.1 94.8998 205.3C116.5 211 139.6 213.2 158.6 224.9C168.6 231 176.9 239.5 186.8 245.7C208 258.9 236.4 260.5 258 247.9C279.5 235.2 292.2 208.2 286.2 183.9C282.4 168.6 272.3 155.8 266.7 141.1C261.9 128.5 260.4 114.7 262.6 101.4C264.8 87.7 270.6 74.8 272 60.9C273.2 49.3 269.1 34.6 262.7 24.8C249.4 4.9 225.6 -2.2 203.1 1.4C186.1 4.1 169.4 12.6 155.2 22.1C148.5 26.6 143.3 32.6 135.8 36.4C128.1 40.3 119.8 42.9 111.4 44.6L108.7 45.2H108.8V45.1Z",
    fill: "#2F32FE",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 81.8L29.2996 89",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 89L29.2996 81.8",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.3 221.6L213.5 228.8",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.3 228.8L213.5 221.6",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1 107.2L284.3 114.4",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1 114.4L284.3 107.2",
    stroke: "#EAEAFE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3998 109.1C82.6998 109.1 85.4998 106.4 85.4998 103C85.4998 99.6 82.7998 96.9 79.3998 96.9C75.9998 96.9 73.2998 99.6 73.2998 103C73.2998 106.4 75.9998 109.1 79.3998 109.1Z",
    stroke: "#EAEAFE",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3996 26.7C64.7996 26.7 66.6996 24.8 66.6996 22.4C66.6996 20 64.7996 18.1 62.3996 18.1C59.9996 18.1 58.0996 20 58.0996 22.4C58.0996 24.8 59.9996 26.7 62.3996 26.7Z",
    stroke: "#EAEAFE",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8 171.2C260.2 171.2 262.1 169.3 262.1 166.9C262.1 164.5 260.2 162.6 257.8 162.6C255.4 162.6 253.5 164.5 253.5 166.9C253.5 169.3 255.4 171.2 257.8 171.2Z",
    stroke: "#EAEAFE",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2 27C207 27 210.1 23.9 210.1 20.1C210.1 16.3 207 13.2 203.2 13.2C199.4 13.2 196.3 16.3 196.3 20.1C196.3 23.9 199.4 27 203.2 27Z",
    stroke: "#EAEAFE",
    strokeWidth: 1.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 145.6V211.4C38 216.7 42.4 221 47.9 221H61.2V257.4L102.5 221H148.1C153.5 221 158 216.7 158 211.4V140.1C158 134.8 153.6 130.5 148.1 130.5H61.9",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9 62.7V141.2C248.9 147.3 243.8 152.3 237.5 152.3H222.1V194.5L174.2 152.3H158",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 130.5V58.7C110 52.6 115.1 47.6 121.4 47.6H225.1",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 193.5H135",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 172.5H135",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 124H231",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 103H231",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 82H231",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 58.3C253.5 53.6 248.4 50.3 243 50.3C237.6 50.3 232.5 53.6 230.4 58.3",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1 63.7001C253 63.7001 261.1 55.7 261.1 45.8C261.1 35.9 253.1 27.8 243.1 27.8C233.1 27.8 225.2 35.8 225.2 45.8C225.2 55.8 233.2 63.7001 243.1 63.7001Z",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1 45.7C245.5 45.7 247.5 43.7 247.5 41.3C247.5 38.9 245.5 36.9 243.1 36.9C240.7 36.9 238.7 38.9 238.7 41.3C238.7 43.7 240.7 45.7 243.1 45.7Z",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5999 141.3C54.4999 136.6 49.3999 133.3 43.9999 133.3C38.5999 133.3 33.4999 136.6 31.3999 141.3",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0997 146.7C53.9997 146.7 62.0997 138.7 62.0997 128.7C62.0997 118.7 54.0997 110.8 44.0997 110.8C34.0997 110.8 26.1997 118.8 26.1997 128.7C26.1997 138.6 34.1997 146.7 44.0997 146.7Z",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0997 128.7C46.4997 128.7 48.4997 126.7 48.4997 124.3C48.4997 121.9 46.4997 119.9 44.0997 119.9C41.6997 119.9 39.6997 121.9 39.6997 124.3C39.6997 126.7 41.6997 128.7 44.0997 128.7Z",
    stroke: "#EAEAFE",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 259,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDark);
export default __webpack_public_path__ + "static/media/empty-dark.b1f30d45.svg";
export { ForwardRef as ReactComponent };